import React from "react";
// Use jsx for require()
const config = require(`../../config/${process.env.REACT_APP_ENV}/env.json`);

/**
 * @typedef {Object} ConfigVar
 * @property {require("../../config/pfaas-dev/env.json")} config - default to pfaas-dev for pfaas stage
 */

/**
 * Custon hook for accessing config variables
 * @returns {ConfigVar}
 */
const useConfig = () => {
  return React.useMemo(() => ({ config }));
};

export default useConfig;
